$(document).ready(function(){
  $('.testimonials-slider').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows:true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          dots:true,
        }
      }
    ]
  });  


  $('.popup-youtube_video').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  $('#shopify-section-162143338341ae8da6 .grid').slick({
    mobileFirst: true, 
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick"
      }
    ]
  });

// $('#shopify-product-reviews').attr('class', 'hide');
//   $(document).on('click', '.review_btn .btn', function () {
//     console.log('here');
//     if ($('#shopify-product-reviews').attr('class') == 'hide') {
//       $('#shopify-product-reviews').attr('class', 'show');
//     } else {
//       $('#shopify-product-reviews').attr('class', 'hide');
//     }
//   });

});

$(document).ready(function(){
  $('.cart-link').hover( function(event){
    renderCart();
  });
  
  $(document).on('click', '.cart-link', function (event) {
      $('.mini1-cart-layout').show();
  });
  
  $(document).on('click', '.mini-cart-close', function (event) {
      $('.mini1-cart-layout').hide();
  });

  
  $(document).on('click', '.grid_add_to_cart', function (event) {
    event.preventDefault();
    var variant_id = $(this).parents(".product_add_to_cart").find(".var_id_hidden").val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        'quantity':1,
        'id': variant_id,
      },
      dataType: 'json',
      success: function(cart) {
        $('.mini1-cart-layout').show();
        renderCart(cart);
      },error: function (textStatus, errorThrown) {
        $('.error-for-add-to-cart').show();
        $('.error-for-add-to-cart').html( textStatus.responseJSON.description);
        console.log(textStatus.responseJSON.description);
      }
    });
  });
  
  
  
$(document).on('click', '.custom-add-to-cart-button', function (event) {
  event.preventDefault();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      'quantity': $('.product_btn_main').find('.js-qty__num').val(),
      'id': $('.product-single__variants').find(":selected").val(),
    },
    dataType: 'json',
    success: function(cart) {
     $('.mini1-cart-layout').show();
      renderCart(cart);
    },error: function (textStatus, errorThrown) {
      $('.error-for-add-to-cart').show();
      $('.error-for-add-to-cart').html( textStatus.responseJSON.description);
      console.log(textStatus.responseJSON.description);
    }
  });
});
$(document).on('click', '.mini-cart-delete ', function (event) {
  var productId = $(this).attr('data-id');
  console.log("productId",productId);
  $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: productId
        },
        success: function (cart){
          console.log('success');
    		renderCart(cart);
          
            },error: function (textStatus, errorThrown) {
              console.log(textStatus.responseJSON.description);

            }
  	});
});

  
  
  $(document).on('click', '.article_add_to_cart', function (event) {
    event.preventDefault();
    var variant_id = $(this).attr("data-id");
    var qty = $(".article_qty").val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        'quantity':qty,
        'id': variant_id,
      },
      dataType: 'json',
      success: function(cart) {
        $('.mini1-cart-layout').show();
        renderCart(cart);
      },error: function (textStatus, errorThrown) {
        console.log(textStatus.responseJSON.description);
        alert(textStatus.responseJSON.description);
      }
    });
  });
  
  
  function renderCart(cart){
      $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function(cart) {
            console.log(cart);
			var items = "" ;
            cart.items.forEach(function(item, index) {
              var item_price =  theme.Currency.formatMoney(item.price, theme.settings.moneyFormat);
              $('.cart-link__bubble').addClass('cart-link__bubble--visible');
               items += "<li class='mini-cart-item-li'> "+
                                     "<div class='mini-li-block'> "+
                                       "<div class='mini-li-alert' role='alert'></div>"+ 
                                       "<div class='mini-li-item cart-li-item item'>"+
                                         "<a href='" + item.url + "' aria-label='' data-id='"+ item.id +"' class='mini-cart-item-link'>"+ 
                                              "<div style='flex-shrink: 0; flex: 0 0 29%; align-self: center;'><img src='"+ item.image +"' srcset='' alt='' class='mini-cart-item-image'></div>"+
                                              "<div class='mini-cart-iteams-block mini-cart-item-link-text' > "+
                                                  "<div class='_ps-zEB'> "+
                                                      "<dd> "+
                                                          "<div class='inline-block mini-cart-item-money-block'> "+
                                                              "<span class='mini-cart-item-money'>"+ item_price +"</span>"+
                                                          "</div> "+
                                                      "</dd>"+ 
                                                  "</div> "+
                                                   "<div class='mini-cart-title-block'> "+
                                                     "<span>"+ item.title +"</span> "+
                                                   "</div> "+
                                                   "<div class='mini-cart-qty-block'> "+
                                                        "<dt> <abbr title='Quantité'>Antal</abbr> </dt>"+
                                                        "<dd class='mini-cart-qty-block'>"+ item.quantity +"</dd>"+ 
                                                   "</div> "+
                                                   "<div class='mini-cart-variant-block'> "+
                                                      "<div class='_3c2M1FE'> "+
                                                        "<dt class='_1SsJlmy'></dt> "+
                                                        "<dd></dd> "+
                                                      "</div>"+ 
                                                     "<div class='_2Z5GEI3'> "+
                                                          "<dt class='_1SsJlmy'></dt> "+
                                                          "<dd></dd> "+
                                                     "</div> "+
                                                     
                                                  "</div>"+
                                              "</div> "+
                                         "</a> "+
                                        "<button aria-label='Supprimer cet article' data-id='"+ item.id +"' class='mini-cart-delete'></button> "+
                                       "</div>"+
                                          "<div class='niMMpP3'> </div> "+
                                     "</div> "+
                                   "</li>";

            });
            
//               var total = Shopify.formatMoney(cart.total_price).replace('$', "");
              var total =  theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
              $('#mini-cart-subtotal').html(total);
              if(cart.item_count > 0){
                $('.item-li').html(items);
              }else{
              $('.item-li').html("<li style='padding: 20px; font-size: 20px;text-align: center;}'>Kurven er tom</li>");
              }
              $(".mini1-cart-layout").show();
              $('.cart-link__bubble').show();
              $('.cart-link__bubble').text(cart.item_count);
          }
      });
  }
});


$(document).on("click",".read_more",function(){
  if($(this).hasClass("expanded")){
    $(this).removeClass("expanded");
     $(".product-single__description").css("max-height","220px");
    $(this).text("Læs mere");
  }else{
   $(this).addClass("expanded");
     $(".product-single__description").css("max-height","100%");
    $(this).text("Læs mindre");
  }
   $('html, body').animate({
        scrollTop: $(".product-single__title").offset().top
    }, 0);
});

// $(document).on("click",".add_review",function(){
// $('html, body').animate({
//         scrollTop: $("#shopify-product-reviews").offset().top - 120
//     }, 0);
// });


$(document).on("click",".blog_first .blog_main",function(){
  $(this).find(".blog_btn a").click();
});
